export const favoriteFilterKeys = {
  cashiers: 'favAdmCSRCashiers',
  currencies: 'favAdmCSRCurrencies',
  brands: 'favAdmCSRBrands',
  platformIds: 'favAdmCSRPlatformIds',
}

export const reportStorageProps = {
  type: 'cashier-statistics-report',
  target: 'filters',
  tableSettingsTarget: 'table-settings',
  savedReportTarget: 'cashier-statistics-report-settings',
  savedReportFavoritesTarget: 'cashier-statistics-report-favorites',
  savedReportDefaultTarget: 'cashier-statistics-report-default',
  exceptions: ['group_by', 'period', 'sent_from', 'sent_to', 'displayInPlayerCurrency'],
  exceptionsIds: ['currencies', 'cashiers', 'brands', 'platformIds'],
  exceptionsStr: [],
  maxFavoriteReports: 10,
}
